const getters = {
  accept: state => state.app.accept,
  conutry: state => state.app.conutry,
  alertinfo: state => state.app.alertinfo,
  isGlobal: state => state.app.isGlobal,
  showLoading: state => state.app.showLoading,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js